import type { ReactNode } from 'react';

export const symbol_chess_knight: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M261-79q-26 0-43-17.63-17-17.62-17-42.37v-100q0-17.49 9-31.56T234-293l216-107v-98l-161 80q-11 5-23.07 8t-24.14 3q-28.79 0-54.57-15.04t-39.84-43.24Q134-490.66 136-519.33 138-548 154-571l133-197-44-65q-11-15-2-31t27-16h171q134 0 227.5 92.42T760-562v423q0 24.75-17.62 42.37Q724.75-79 700-79H261Zm0-60h439v-423q0-107.5-76.12-182.75Q547.75-820 439-820H324l24 35q5 7.65 5 16.82 0 9.18-5 17.18L204-537q-7 10-7.5 21.9-.5 11.9 4.5 23.1 7 14 19 19.5t22 5.5q7 0 21-5l205-102q15-8 29 .75T511-547v147q0 17.49-9 31.56T478-346L261-239v100Zm189-359Z"
		/>
	</svg>
);
